"use strict";

import AdPixel from "./components/AdPixel.js";
import { metrika } from "./metrika";

const VueMetrika = {
  install(Vue) {
    Vue.prototype.$metrika = metrika;

    Vue.component("ad-pixel", AdPixel);

    Vue.filter("randomizeLink", v => {
      if (typeof v !== "string") {
        return v;
      }
      return metrika.randomizeLink(v);
    });
  }
};

export { VueMetrika };
